import React from 'react'

interface ArrowRightProps {
  className?: string
  size?: number
  color?: string
}

const ArrowRight: React.FC<ArrowRightProps> = ({ className = '', size = 24, color = 'currentColor' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round">
      <path d="M12 6L18 12L12 18" />
    </svg>
  )
}

export default ArrowRight
